import { inject, DestroyRef } from '@angular/core';
import {
  CanActivateFn,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { defer, from, of } from 'rxjs';
import {
  filter,
  map,
  take,
  switchMap,
  finalize
} from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingController } from '@ionic/angular';
import {
  AuthenticationService,
  AuthenticatedUser
} from '../services/authentication.service';

// Toggle this to skip showing the spinner
const SKIP_AUTH_LOADING = false;

export const unauthenticatedCanActivateGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);
  const destroyRef = inject(DestroyRef);
  const loadingCtrl = inject(LoadingController);

  return defer(() => {
    if (SKIP_AUTH_LOADING) {
      return auth.currentUser$.pipe(
        filter((u): u is AuthenticatedUser | null => u !== undefined),
        take(1),
        map(user => {
          return user ? router.createUrlTree(['/console']) : true;
        }),
        takeUntilDestroyed(destroyRef)
      );
    }

    let loaderEl: HTMLIonLoadingElement;

    return from(loadingCtrl.create({
      // message: 'Checking authentication…',
      spinner: 'crescent'
    })).pipe(
      switchMap(loader => {
        loaderEl = loader;
        return from(loader.present());
      }),
      switchMap(() =>
        auth.currentUser$.pipe(
          filter((u): u is AuthenticatedUser | null => u !== undefined),
          take(1),
          map(user => {
            return user ? router.createUrlTree(['/console']) : true;
          })
        )
      ),
      finalize(() => {
        loaderEl?.dismiss();
      }),
      takeUntilDestroyed(destroyRef)
    );
  });
};